export default {"src":"/_next/static/media/icon_withdrawal_option_fast_bank.2c9c0a35.svg","height":29,"width":33,"blurWidth":0,"blurHeight":0};